import { actionTypes } from '../actions/types';
import { CustomerCaseInfoLandingPage, InterestsAndFeesWeb } from '../generated-types';

type AppActions = import('../actions/types').AppActions;

export interface LandingPageApplicationInfo {
    advisorApplication: boolean;
    applicationId: string;
    applicationStatus: string;
    lbsBankRegNr?: string;
    loanAmount: number;
    loanProduct: string;
    loanType: string;
    vehicleRegistrationNumber?: string;
    mainApplicant: boolean;
    vehicleEuroTaxDataFetched?: boolean;
    vehicleEuroTaxDataErrors?: any;
}

export interface CustomerCaseInfoLandingPageUpdate extends CustomerCaseInfoLandingPage {
    vehicleEuroTaxDataFetched: boolean;
    regNrValidated?: boolean;
}

export interface OngoingApplicationReducer {
    landingPageApplicationInfo: CustomerCaseInfoLandingPage[];
    selectedInterestsAndFees: InterestsAndFeesWeb | null;
    selectedError: any;
}

export const initialState: OngoingApplicationReducer = {
    landingPageApplicationInfo: [],
    selectedInterestsAndFees: null,
    selectedError: null,
};

const getSelectedApp = (apps: CustomerCaseInfoLandingPage[], applicationId: string) => {
    const currentApp = apps.find((app: CustomerCaseInfoLandingPage) => {
        return app.applicationId === applicationId;
    });
    return currentApp;
};

export const ongoingApplicationsReducer = (
    state = initialState,
    action: AppActions = {} as AppActions,
): OngoingApplicationReducer => {
    switch (action.type) {
        case actionTypes.FETCH_ONGOING_APPLICATIONS_FULFILLED: {
            return {
                ...state,
                landingPageApplicationInfo: [...action.payload],
            };
        }
        case actionTypes.FETCH_ONGOING_APPLICATIONS_EUROTAX_FULFILLED: {
            const apps = [...state.landingPageApplicationInfo];
            const currentApp = getSelectedApp(apps, action.applicationId) as CustomerCaseInfoLandingPageUpdate;
            if (currentApp) {
                currentApp.vehicleEuroTaxDataFetched = true;
                currentApp.regNrValidated = true;
            }

            return {
                ...state,
                landingPageApplicationInfo: apps,
                selectedError: null,
            };
        }
        case actionTypes.FETCH_ONGOING_APPLICATIONS_EUROTAX_CLEAR: {
            const apps = [...state.landingPageApplicationInfo];
            const currentApp = getSelectedApp(apps, action.applicationId) as CustomerCaseInfoLandingPageUpdate;
            if (currentApp) {
                currentApp.vehicleEuroTaxDataFetched = false;
                currentApp.regNrValidated = false;
            }

            return {
                ...state,
                landingPageApplicationInfo: apps,
            };
        }

        case actionTypes.UPGRADE_ONGOING_APPLICATION_FAILED: {
            const apps = [...state.landingPageApplicationInfo];
            const currentApp = getSelectedApp(apps, action.applicationId) as CustomerCaseInfoLandingPageUpdate;

            if (currentApp) {
                currentApp.vehicleEuroTaxDataFetched = false;
                currentApp.regNrValidated = false;
            }

            return {
                ...state,
                landingPageApplicationInfo: apps,
            };
        }

        case actionTypes.UPGRADE_ONGOING_APPLICATION_SUCCESS: {
            return {
                ...state,
                selectedInterestsAndFees: null,
                selectedError: null,
            };
        }

        case actionTypes.FETCH_ONGOING_APPLICATIONS_EUROTAX_FAILED: {
            return {
                ...state,
                selectedError: action.payload.errorName,
            };
        }

        case actionTypes.FETCH_OBJECT_CALCULATOR_DATA_FULFILLED: {
            return {
                ...state,
                selectedInterestsAndFees: action.interestsAndFees,
                selectedError: null,
            };
        }

        default:
            return state;
    }
};
